const PHONE_REGX = /^1[3-9]\d(\s\d{4}){2}$/;

const requireRule = label => {
  return {
    required: true,
    asyncValidator: (rule, value) => {
      if ((typeof value === 'string' && value.trim() !== '') || value) {
        return Promise.resolve();
      } else {
        return Promise.reject(`请输入${label}`);
      }
    },
    message: `请输入${label}`,
  };
};

const requireRules = label => {
  return [requireRule(label || '')];
};

const generateSameRule = (label, image, code) => {
  return {
    // validator: (rule, value) => code === value,
    asyncValidator: (rule, value) => {
      if (!code) {
        return Promise.reject(`请上传${image}`);
      } else if (code !== value) {
        return Promise.reject(`${label}与照片不一致`);
      } else {
        return Promise.resolve();
      }
    },
  };
};

const phoneRules = label => {
  return [
    requireRule(label || ''),
    {
      asyncValidator: (rule, value) => {
        if (PHONE_REGX.test(value)) {
          return Promise.resolve();
        } else {
          return Promise.reject(`手机号格式错误`);
        }
      },
    },
  ];
};

const sameRules = (label, image, code) => {
  return [requireRule(label || ''), generateSameRule(label, image, code)];
};

export { requireRules, sameRules, phoneRules };
